import DataIndependent from './Independent.js';
import DataIntern from './Intern.js';
import DataTestimonyClassic from './TestimonyClassic.js';
import DataTestimonyHDI from './TestimonyHDI.js';
import DataTestimonySilo from './TestimonySilo.js';
import React from 'react';
import Fourrage from "./Fourrage.js";

export default function renderDataComponent(data, mainColor, category, isForages) {
  if (!data?.type) return null;

  let retrievedColor = null;

  if (window.TRIALS) {
    retrievedColor = JSON.parse(window.TRIALS).filter(
      (item) => item.id === data.id
    ).color;

    retrievedColor = 'bg-brand-600';
  }

  switch (data.type) {
    case 'intern':
      return isForages ?
        <Fourrage trial={data} mainColor={mainColor}/> :
        <DataIntern
          trial={data}
          mainColor={retrievedColor ? retrievedColor : mainColor}
          category={category}
        />
      ;
    case 'testimony_classic':
      return (
        <DataTestimonyClassic
          trial={data}
          mainColor={mainColor}
          category={category}
        />
      );
    case 'testimony_silo_comparison':
      return (
        <DataTestimonySilo
          trial={data}
          mainColor={mainColor}
          category={category}
        />
      );
    case 'testimony_hdi_review':
      return (
        <DataTestimonyHDI
          trial={data}
          mainColor={mainColor}
          category={category}
        />
      );
    case 'independent':
    case 'independent_hdi':
      return (
        <DataIndependent
          data={data}
          mainColor={mainColor}
          category={category}
        />
      );

    default:
      return null;
  }
}
